var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "48px",
    height: "px",
    viewBox: "0 0 48 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(52.156863%,31.764706%,96.470588%)",
      fillOpacity: 1
    },
    d: "M 43.792969 25.945312 L 35.929688 32.925781 L 23.578125 32.925781 L 16.84375 38.914062 L 16.84375 32.925781 L 6.738281 32.925781 L 6.738281 3.992188 L 43.792969 3.992188 Z M 2.238281 0 L -0.0078125 7.984375 L -0.0078125 43.90625 L 10.097656 43.90625 L 10.097656 48.894531 L 15.710938 48.894531 L 21.332031 43.90625 L 30.316406 43.90625 L 48.28125 27.941406 L 48.28125 0 Z M 2.238281 0 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(52.156863%,31.764706%,96.470588%)",
      fillOpacity: 1
    },
    d: "M 19.089844 23.957031 L 23.582031 23.957031 L 23.582031 11.976562 L 19.089844 11.976562 Z M 31.4375 23.957031 L 35.929688 23.957031 L 35.929688 11.976562 L 31.4375 11.976562 Z M 31.4375 23.957031 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitch);
export default __webpack_public_path__ + "static/media/twitch.c30eee40.svg";
export { ForwardRef as ReactComponent };